import {SAARLAND_BOUNDS} from "../enum";

export const isInSaarlandBounds = (lat, lng) => {
  return (
    lat >= SAARLAND_BOUNDS.minLat &&
    lat <= SAARLAND_BOUNDS.maxLat &&
    lng >= SAARLAND_BOUNDS.minLng &&
    lng <= SAARLAND_BOUNDS.maxLng
  );
};
